
import { Zone, Gym, UserRole, Slot } from './types';

export const ZONES: Zone[] = [
  { id: 'Z1', name: 'Centro / Microcentro' },
  { id: 'Z2', name: 'Norte / Residencial' },
  { id: 'Z3', name: 'Sur / Industrial' },
  { id: 'Z4', name: 'Este / Comercial' },
  { id: 'Z5', name: 'Oeste / Universitario' }
];

export const MOCK_GYMS: Gym[] = [
  { 
    id: 'G1', 
    name: 'Iron Temple', 
    zoneId: 'Z1', 
    address: 'Av. Corrientes 1234', 
    description: 'Especialistas en Powerlifting y Musculación pesada.',
    capacityPerSlot: 5,
    image: 'https://picsum.photos/seed/gym1/800/400'
  },
  { 
    id: 'G2', 
    name: 'Zenith Fitness', 
    zoneId: 'Z2', 
    address: 'Calle Las Heras 456', 
    description: 'Enfoque funcional y bienestar integral.',
    capacityPerSlot: 8,
    image: 'https://picsum.photos/seed/gym2/800/400'
  },
  { 
    id: 'G3', 
    name: 'Spartan Box', 
    zoneId: 'Z3', 
    address: 'Ruta 9 Km 12', 
    description: 'Crossfit y entrenamiento de alta intensidad.',
    capacityPerSlot: 10,
    image: 'https://picsum.photos/seed/gym3/800/400'
  }
];

// Added isActive: true to each slot to fix interface compliance errors
export const MOCK_SLOTS: Slot[] = [
  { id: 'S1', gymId: 'G1', dayOfWeek: 1, startTime: '08:00', endTime: '09:30', capacity: 5, isActive: true },
  { id: 'S2', gymId: 'G1', dayOfWeek: 1, startTime: '10:00', endTime: '11:30', capacity: 5, isActive: true },
  { id: 'S3', gymId: 'G1', dayOfWeek: 1, startTime: '18:00', endTime: '19:30', capacity: 3, isActive: true },
  { id: 'S4', gymId: 'G2', dayOfWeek: 1, startTime: '09:00', endTime: '10:30', capacity: 8, isActive: true },
  { id: 'S5', gymId: 'G3', dayOfWeek: 2, startTime: '17:00', endTime: '18:30', capacity: 10, isActive: true }
];

export const WEEKLY_PASS_LIMIT = 2;